export default __webpack_public_path__ + "static/media/angbao-bonus.5c3b2694.webp";